<template>
  <div>
    <b-nav-item-dropdown right no-caret>
      <template slot="button-content">
        <i class="fa fa-user-circle-o fa-lg" style="font-size: 30px;"></i>
      </template>
      <!--<b-dropdown-header tag="div" class="text-center"><strong>Account</strong></b-dropdown-header>
        <b-dropdown-item><i class="fa fa-bell-o"></i> Updates<b-badge variant="info">{{itemsCount}}</b-badge></b-dropdown-item>
        <b-dropdown-item><i class="fa fa-envelope-o"></i> Messages<b-badge variant="success">{{itemsCount}}</b-badge></b-dropdown-item>                                                  
        <b-dropdown-item><i class="fa fa-tasks"></i> Tasks<b-badge variant="danger">{{itemsCount}}</b-badge></b-dropdown-item>
        <b-dropdown-item><i class="fa fa-comments"></i> Comments<b-badge variant="warning">{{itemsCount}}</b-badge></b-dropdown-item>                                                   
        <b-dropdown-header tag="div" class="text-center"><strong>Settings</strong></b-dropdown-header>
        <b-dropdown-item><i class="fa fa-user"></i> Profile</b-dropdown-item>
        <b-dropdown-item><i class="fa fa-wrench"></i> Settings</b-dropdown-item>
        <b-dropdown-item><i class="fa fa-usd"></i> Payments<b-badge variant="secondary">{{itemsCount}}</b-badge></b-dropdown-item>
        <b-dropdown-item><i class="fa fa-file"></i> Projects<b-badge variant="primary">{{itemsCount}}</b-badge></b-dropdown-item>
        <b-dropdown-divider></b-dropdown-divider>                            
        <b-dropdown-item><i class="fa fa-shield"></i> Lock Account</b-dropdown-item> -->
       <b-dropdown-item @click.prevent="showplan()"
        ><i class="fa fa-tasks"></i> Current Plan</b-dropdown-item
      >
      <b-dropdown-item @click.prevent="reset_password"
        ><i class="fa fa-key"></i> Reset Password</b-dropdown-item
      >
      <b-dropdown-item @click.prevent="logout"
        ><i class="fa fa-lock"></i> Logout</b-dropdown-item
      >
      
    </b-nav-item-dropdown>

    <b-modal
      title="Reset Password"
      size="md"
      v-model="resetModal"
      hide-footer
      style="margin: auto;"
    >
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <b-col sm="12">
              <div
                class="alert alert-success"
                v-if="errorMessage.message != ''"
                style="text-align: center;"
              >
                {{ errorMessage.message }}
              </div>
            </b-col>
          </div>
          <div class="row">
            <b-col sm="12">
              <b-form-group>
                <label for="name"> New Password :</label>
                <b-form-input
                  type="password"
                  v-model="password.new"
                  :class="{ 'is-invalid': hasErrors.new }"
                  placeholder="New Password"
                ></b-form-input>
                <small class="form-text text-muted" v-if="hasErrors.new"
                  ><strong style="color: red;">{{
                    errorMessage.new
                  }}</strong></small
                >
              </b-form-group>
            </b-col>
          </div>
          <div class="row">
            <b-col sm="12">
              <b-form-group>
                <label for="name"> Confirm Password :</label>
                <b-form-input
                  type="password"
                  v-model="password.confirm"
                  :class="{ 'is-invalid': hasErrors.confirm }"
                  placeholder="Confirm Password"
                ></b-form-input>
                <small class="form-text text-muted" v-if="hasErrors.confirm"
                  ><strong style="color: red;">{{
                    errorMessage.confirm
                  }}</strong></small
                >
              </b-form-group>
            </b-col>
          </div>
          <b-row>
            <b-col sm="12">
              <button
                type="save"
                class="btn btn-sm btn-primary"
                @click.prevent="Submit()"
              >
                <i class="fa fa-dot-circle-o"></i> Save
              </button>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-modal>
      <b-modal
          title="Current Plan"
          no-close-on-esc
          no-close-on-backdrop
          size="lg"
          hide-footer
          class="modal-warning"
          v-model="planModal"
          @ok="planModal = true"
          ok-variant="warning"
        >
         <b-collapse id="collapse3" visible>
            <table v-if="plan_dt !== null">
            
              <tr>
                <th></th>
                <th>
                  <input
                    v-model="selplan"
                    type="radio"
                    id="free"
                    name="selplan"
                    checked
                    v-bind:value="plan_dt[0].plan_type"
                  />&nbsp;{{ plan_dt[0].plan_label}}
                </th>
                <th>
                  <input
                    v-model="selplan"
                    type="radio"
                    id="basic"
                    name="selplan"
                    v-bind:value="plan_dt[1].plan_type"
                  />&nbsp;{{ plan_dt[1].plan_label}}
                </th>
                <th>
                  <input
                    v-model="selplan"
                    type="radio"
                    id="standard"
                    name="selplan"
                    v-bind:value="plan_dt[2].plan_type"
                  />&nbsp;{{ plan_dt[2].plan_label}}
                </th>
                <th>
                  <input
                    v-model="selplan"
                    type="radio"
                    id="professional"
                    name="selplan"
                    v-bind:value="plan_dt[3].plan_type"
                  />&nbsp;{{ plan_dt[3].plan_label}}
                </th>
              </tr>
              <tr>
                <td></td>
                <td>
                  <i
                    class="fa fa-inr"
                    aria-hidden="true"
                    style="color: rgb(221, 120, 89); font-size: 30px;"
                  ></i
                  ><span style="color: rgb(221, 120, 89); font-size: 32px;">{{
                    plan_dt[0].cost
                  }}</span>
                </td>
                <td>
                  <i
                    class="fa fa-inr"
                    aria-hidden="true"
                    style="color: rgb(221, 120, 89); font-size: 30px;"
                  ></i
                  ><span style="color: rgb(221, 120, 89); font-size: 32px;">{{
                    plan_dt[1].cost
                  }}</span>
                </td>
                <td>
                  <i
                    class="fa fa-inr"
                    aria-hidden="true"
                    style="color: rgb(221, 120, 89); font-size: 30px;"
                  ></i
                  ><span style="color: rgb(221, 120, 89); font-size: 32px;">{{
                    plan_dt[2].cost
                  }}</span>
                </td>
                <td>
                  <i class="fa fa-inr" aria-hidden="true" style="color: rgb(221, 120, 89); font-size: 30px;"></i>
                  <span style="color: rgb(221, 120, 89); font-size: 32px;">{{plan_dt[3].cost}}</span>
                </td>
              </tr>
              <tr>
                <td></td>
                <td>
                  <span style="color: rgb(221, 120, 89); font-size: 12px;"
                    >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;plus gst (per annum)</span
                  >
                </td>
                <td>
                  <span style="color: rgb(221, 120, 89); font-size: 12px;"
                    >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;plus gst (per annum)</span
                  >
                </td>
                <td>
                  <span style="color: rgb(221, 120, 89); font-size: 12px;"
                    >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;plus gst (per annum)</span
                  >
                </td>
                <td>
                  <span style="color: rgb(221, 120, 89); font-size: 12px;"
                    >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;plus gst (per annum)</span
                  >
                </td>
              </tr>
               <tr>
                <td style="font-weight: bold;">Warehouse / Shop</td>
                <td v-if="plan_dt[0].shop_count === '0'">Unlimited</td>
                <td v-else>{{ plan_dt[0].shop_count }}</td>
                <td v-if="plan_dt[1].shop_count === '0'">Unlimited</td>
                <td v-else>{{ plan_dt[1].shop_count }}</td>
                <td v-if="plan_dt[2].shop_count === '0'">Unlimited</td>
                <td v-else>{{ plan_dt[2].shop_count }}</td>
                <td v-if="plan_dt[3].shop_count === '0'">Unlimited</td>
                <td v-else>{{ plan_dt[3].shop_count }}</td>
              </tr>
              <tr>
                <td style="font-weight: bold;">Max Users Allowed</td>
                <td v-if="plan_dt[0].user_count === '0'">Unlimited</td>
                <td v-else>{{ plan_dt[0].user_count }}</td>
                <td v-if="plan_dt[1].user_count === '0'">Unlimited</td>
                <td v-else>{{ plan_dt[1].user_count }}</td>
                <td v-if="plan_dt[2].user_count === '0'">Unlimited</td>
                <td v-else>{{ plan_dt[2].user_count }}</td>
                <td v-if="plan_dt[3].user_count === '0'">Unlimited</td>
                <td v-else>{{ plan_dt[3].user_count }}</td>
              </tr>
              <tr>
                <td style="font-weight: bold;">Third Party Ecommerce Integration</td>
                <td>
                  <i
                    v-if="plan_dt[0].ecom_int === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[0].ecom_int === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
                <td>
                  <i
                    v-if="plan_dt[1].ecom_int === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[1].ecom_int === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
                <td>
                  <i
                    v-if="plan_dt[2].ecom_int === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[2].ecom_int === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
                <td>
                  <i
                    v-if="plan_dt[3].ecom_int === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[3].ecom_int === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
              </tr>
              <!-- <tr>
                <td style="font-weight: bold;">Invoice</td>
                <td v-if="plan_dt[0].inv_count === '0'">Unlimited</td>
                <td v-else>{{ plan_dt[0].inv_count }}</td>
                <td v-if="plan_dt[1].inv_count === '0'">Unlimited</td>
                <td v-else>{{ plan_dt[1].inv_count }}</td>
                <td v-if="plan_dt[2].inv_count === '0'">Unlimited</td>
                <td v-else>{{ plan_dt[2].inv_count }}</td>
                <td v-if="plan_dt[3].inv_count === '0'">Unlimited</td>
                <td v-else>{{ plan_dt[3].inv_count }}</td>
              </tr> -->
               <tr>
                <td style="font-weight: bold;">Invoices</td>
                <td>
                  <i
                    v-if="plan_dt[0].invoice === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[0].invoice === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
                <td>
                  <i
                    v-if="plan_dt[1].invoice === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[1].invoice === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
                <td>
                  <i
                    v-if="plan_dt[2].invoice === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[2].invoice === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
                <td>
                  <i
                    v-if="plan_dt[3].invoice === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[3].invoice === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
              </tr>
              <tr>
                <td style="font-weight: bold;">Reports</td>
                <td>
                  <i
                    v-if="plan_dt[0].report === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[0].report === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
                <td>
                  <i
                    v-if="plan_dt[1].report === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[1].report === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
                <td>
                  <i
                    v-if="plan_dt[2].report === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[2].report === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
                <td>
                  <i
                    v-if="plan_dt[3].report === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[3].report === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
              </tr>
              <tr>
                <td style="font-weight: bold;">GST Reports</td>
                <td>
                  <i
                    v-if="plan_dt[0].gst_report === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[0].gst_report === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
                <td>
                  <i
                    v-if="plan_dt[1].gst_report === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[1].gst_report === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
                <td>
                  <i
                    v-if="plan_dt[2].gst_report === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[2].gst_report === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
                <td>
                  <i
                    v-if="plan_dt[3].gst_report === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[3].gst_report === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
              </tr>
              <!-- <tr>
                <td style="font-weight: bold;">Balance Payment</td>
                <td>
                  <i
                    v-if="plan_dt[0].bal_payment === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[0].bal_payment === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
                <td>
                  <i
                    v-if="plan_dt[1].bal_payment === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[1].bal_payment === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
                <td>
                  <i
                    v-if="plan_dt[2].bal_payment === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[2].bal_payment === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
                <td>
                  <i
                    v-if="plan_dt[3].bal_payment === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[3].bal_payment === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
              </tr> -->

              <tr>
                <td style="font-weight: bold;">Max no. of Categories Allowed</td>
                <td v-if="plan_dt[0].cat_count === '0'">Unlimited</td>
                <td v-else>{{ plan_dt[0].cat_count }}</td>
                <td v-if="plan_dt[1].cat_count === '0'">Unlimited</td>
                <td v-else>{{ plan_dt[1].cat_count }}</td>
                <td v-if="plan_dt[2].cat_count === '0'">Unlimited</td>
                <td v-else>{{ plan_dt[2].cat_count }}</td>
                <td v-if="plan_dt[3].cat_count === '0'">Unlimited</td>
                <td v-else>{{ plan_dt[3].cat_count }}</td>
              </tr>
              <tr>
                <td style="font-weight: bold;">Max no. of Products Allowed</td>
                <td v-if="plan_dt[0].prod_count === '0'">Unlimited</td>
                <td v-else>{{ plan_dt[0].prod_count }}</td>
                <td v-if="plan_dt[1].prod_count === '0'">Unlimited</td>
                <td v-else>{{ plan_dt[1].prod_count }}</td>
                <td v-if="plan_dt[2].prod_count === '0'">Unlimited</td>
                <td v-else>{{ plan_dt[2].prod_count }}</td>
                <td v-if="plan_dt[3].prod_count === '0'">Unlimited</td>
                <td v-else>{{ plan_dt[3].prod_count }}</td>
              </tr>
              <tr>
                <td style="font-weight: bold;">Sales</td>
                <td>
                  <i
                    v-if="plan_dt[0].sales === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[0].sales === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
                <td>
                  <i
                    v-if="plan_dt[1].sales === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[1].sales === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
                <td>
                  <i
                    v-if="plan_dt[2].sales === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[2].sales === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
                <td>
                  <i
                    v-if="plan_dt[3].sales === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[3].sales === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
              </tr>
              <tr>
                <td style="font-weight: bold;">Purchase</td>
                <td>
                  <i
                    v-if="plan_dt[0].purchase === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[0].purchase === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
                <td>
                  <i
                    v-if="plan_dt[1].purchase === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[1].purchase === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
                <td>
                  <i
                    v-if="plan_dt[2].purchase === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[2].purchase === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
                <td>
                  <i
                    v-if="plan_dt[3].purchase === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[3].purchase === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
              </tr>
              <tr>
                <td style="font-weight: bold;">Max Customers</td>
                <td v-if="plan_dt[0].cust_count === '0'">Unlimited</td>
                <td v-else>{{ plan_dt[0].cust_count }}</td>
                <td v-if="plan_dt[1].cust_count === '0'">Unlimited</td>
                <td v-else>{{ plan_dt[1].cust_count }}</td>
                <td v-if="plan_dt[2].cust_count === '0'">Unlimited</td>
                <td v-else>{{ plan_dt[2].cust_count }}</td>
                <td v-if="plan_dt[3].cust_count === '0'">Unlimited</td>
                <td v-else>{{ plan_dt[3].cust_count }}</td>
              </tr>
              <tr>
                <td style="font-weight: bold;">Max Suppliers</td>
                <td v-if="plan_dt[0].supp_count === '0'">Unlimited</td>
                <td v-else>{{ plan_dt[0].supp_count }}</td>
                <td v-if="plan_dt[1].supp_count === '0'">Unlimited</td>
                <td v-else>{{ plan_dt[1].supp_count }}</td>
                <td v-if="plan_dt[2].supp_count === '0'">Unlimited</td>
                <td v-else>{{ plan_dt[2].supp_count }}</td>
                <td v-if="plan_dt[3].supp_count === '0'">Unlimited</td>
                <td v-else>{{ plan_dt[3].supp_count }}</td>
              </tr>
              <tr>
                <td style="font-weight: bold;">Barcodes</td>
                <td>
                  <i
                    v-if="plan_dt[0].barcode === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[0].barcode === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
                <td>
                  <i
                    v-if="plan_dt[1].barcode === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[1].barcode === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
                <td>
                  <i
                    v-if="plan_dt[2].barcode === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[2].barcode === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
                <td>
                  <i
                    v-if="plan_dt[3].barcode === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[3].barcode === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
              </tr>
              <tr>
                <td style="font-weight: bold;">Desktop Application</td>
                <td>
                  <i
                    v-if="plan_dt[0].desktop_app === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[0].desktop_app === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
                <td>
                  <i
                    v-if="plan_dt[1].desktop_app === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[1].desktop_app === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
                <td>
                  <i
                    v-if="plan_dt[2].desktop_app === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[2].desktop_app === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
                <td>
                  <i
                    v-if="plan_dt[3].desktop_app === false"
                    class="fa fa-times"
                    aria-hidden="true"
                    style="color: red; font-size: 17px;"
                  ></i
                  ><i
                    v-if="plan_dt[3].desktop_app === true"
                    class="fa fa-check"
                    aria-hidden="true"
                    style="color: green; font-size: 17px;"
                  ></i>
                </td>
              </tr>
              <tr>
                <td colspan="5" style="text-align: center;">
                  <button disabled
                    class="btn btn-lg btn-primary btn-pill"
                    type="button"
                    @click="plan_select"
                  >
                    Submit
                  </button>
                </td>
              </tr>
              
            </table>
          </b-collapse>
        </b-modal>


  </div>
</template>
<script>
import Spinner from "../../spinner.vue";
export default {
  name: "header-dropdown",
  components: {
    Spinner,
  },
  data: () => {
    return {
      planModal: false,
      selplan:null,
      plan_dt: null,
      loading: false,
      resetModal: false,
      password: {
        new: "",
        confirm: "",
      },
      hasErrors: {
        new: false,
        confirm: false,
      },
      errorMessage: {
        new: "",
        confirm: "",
        message: "",
      },
      itemsCount: 42,
    };
  },
  created(){
      Promise.all([this.plan()]).then((ret_val) => {
      this.plan_dt = this.plan_dt_save;
      //this.city1();
    });
  },
  methods: {
    logout() {
      var _this = this;
      _this.loading = true;
      // this.$http
      //   .post("/api/users/logout")
      //   .then(function (response) {
      //     _this.loading = false;
      //   })
      //   .catch(function (error) {
      //     _this.loading = false;
      //   });
      console.log(!localStorage.getItem('authCatgeory'))
      if(localStorage.getItem('authCatgeory')=='customer'){
        localStorage.clear();
      _this.$store.commit("SET_AUTH_USER", null);
      _this.$router.push("/customerlogin");
      }else{
        localStorage.clear();
      _this.$store.commit("SET_AUTH_USER", null);
      _this.$router.push("/");
      }
    
    },
    reset_password() {
      this.errorMessage.message = "";
      this.password.new = "";
      this.password.confirm = "";
      this.reset_all();
      this.resetModal = true;
    },
    reset_all() {
      this.hasErrors.new = false;
      this.hasErrors.confirm = false;
      this.errorMessage.new = "";
      this.errorMessage.confirm = "";
    },
    Submit() {
      this.errorMessage.message = "";
      this.reset_all();
      var submit = 0;
      var pass = /^((?!.*[\s])(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%]).{8,20})$/;
      if (this.password.new.length == 0) {
        submit = 1;
        this.hasErrors.new = true;
        this.errorMessage.new = "Password Required";
      } else if (pass.test(this.password.new) == false) {
        submit = 1;
        this.hasErrors.new = true;
        this.errorMessage.new =
          "8 characters including 1 uppercase letter, 1 special character & alphanumeric characters without space";
      }
      if (this.password.confirm.length == 0) {
        submit = 1;
        this.hasErrors.confirm = true;
        this.errorMessage.confirm = "Confirm Password Required";
      } else if (this.password.confirm != this.password.new) {
        submit = 1;
        this.hasErrors.confirm = true;
        this.errorMessage.confirm =
          "Password and Confirm Password does not match";
      }
      if (submit == 0) {
        if(localStorage.getItem('authCatgeory')=='customer'){
          this. handleCustomerSubmit()
        }else{
          this.handleSubmit();
        }
       
      }
    },
    handleCustomerSubmit() {
      var _this = this;
      var pass = {};
      _this.loading = true;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      pass.newPassword = this.password.new;
      pass.cust_phone =   localStorage.getItem('authUserid')
      console.log("the new password for " +pass.cust_phone+ "  is: " +pass.newPassword)
      this.$http.post("/api/customers/reset_password", pass).then(function (response) {
          _this.reset_password();
          _this.reset_all();
          _this.loading = false;
          _this.errorMessage.message = " Password Changed Successfully !!";
        })
        .catch(function (error) {
          _this.loading = false;
        });
    },
    handleSubmit() {
      var _this = this;
      var pass = {};
      _this.loading = true;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      pass.newPassword = this.password.new;
      this.$http
        .post("/api/users/reset-password", pass)
        .then(function (response) {
          _this.reset_password();
          _this.reset_all();
          _this.loading = false;
          _this.errorMessage.message = " Password Changed Successfully !!";
        })
        .catch(function (error) {
          _this.loading = false;
        });
    },
    plan_select() {
      this.planModal = false;
      // this.registerData.plan = this.refPlan[parseInt(this.selplan)];
      this.registerData.plan = this.plan_dt[parseInt(this.selplan)]['plan_label']
      this.registerData.selplan = this.selplan;
    },
    async plan() {
      var _this = this;
      this.plan_dt_save = {};
      this.$http
        .get("/api/plans")
        .then(function (response) {
          for (var i = 0; i < response.data.length; i++) {
            _this.plan_dt_save[response.data[i]["plan_type"]] = response.data[i];
            if (i === response.data.length - 1) {
              if(_this.$route.query.type !== undefined && _this.$route.query.type !== null){
                _this.registerData.plan = _this.plan_dt_save[parseInt(_this.$route.query.type)]['plan_label']
                _this.registerData.selplan = _this.plan_dt_save[parseInt(_this.$route.query.type)]['plan_type']
                
                _this.selplan = _this.$route.query.type.toString()
              }
              return Promise.resolve(true);
            }
          }
        }).catch(function (error) {
          console.log(error);
        });
    },
    showplan()
    {
       var _this = this;
      this.$http
        .get("/api/plans/checkplans_type")
        .then(function (response) {
         _this.selplan = response.data[0]["plan_type"];
         _this.planModal = true;
         }).catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Header/HeaderDropdown.vue